import { FC } from "react";
import upArrow from "../../../assets/uparrowFilter.svg";
import downArrow from "../../../assets/downarrowFilter.svg";
import filterpic from "../../../assets/filter-icon.svg";
import { Divider } from "rsuite";

interface MainHeaderProps {
	children?: React.ReactNode;
	topContent?: React.ReactNode;
	bottomContent?: React.ReactNode;
	customClass?: string;
	leftCustomClass?: string;
	rightCustomClass?: string;
	onVisibilityChange: (isVisible: boolean) => void;
	isRightVisible: boolean;
	isIconVisible?:boolean
	setIsRightVisible: (isVisible: boolean) => void;
}

const MainHeader: FC<MainHeaderProps> = ({
	children,
	topContent,
	bottomContent,
	customClass,
	leftCustomClass,
	rightCustomClass,
	onVisibilityChange,
	isRightVisible,
	setIsRightVisible,
	isIconVisible=true
}: MainHeaderProps) => {
	const handleVisibilityChange = () => {
		const newVisibility = !isRightVisible;
		setIsRightVisible(newVisibility);
		onVisibilityChange(newVisibility);
	};

	return (
		<div
			className={`flex flex-col h-auto justify-between items-center bg-white border-b-[0.5px] border-lightGrey shadow-md ${
				customClass ? customClass : ""
			}`}
		>
			{children && children}
			<div className="relative w-full">
				<div className="flex flex-col w-full">
					{topContent && (
						<div
							className={`flex items-center py-[1vh] gap-x-4 w-full justify-end h-[6vh] relative mr-2 border-b border-[#d9d9d9] px-[2%] ${
								leftCustomClass ? leftCustomClass : ""
							}`}
						>
							{topContent}
							<Divider className="maindivider" />
							<div className="ml-[4vh]">
								{bottomContent && (
									<button
										onClick={handleVisibilityChange}
										className={`absolute right-0 top-1/2 transform -translate-y-1/2 pr-[2%] 
											${isIconVisible ? "" : "hidden"} `}
									>
										<img
											className="filter"
											src={filterpic}
											alt={
												isRightVisible
													? "upArrow"
													: "downArrow"
											}
										/>
									</button>
								)}
							</div>
						</div>
					)}
					{bottomContent && (
						<div
							className={`flex items-center gap-x-3 w-full justify-start h-[12vh] px-[2%] ${
								rightCustomClass ? rightCustomClass : ""
							} ${isRightVisible ? "" : "hidden"}`}
						>
							{bottomContent}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default MainHeader;
